import { Box, Button, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddressAPI from "../../api/address";
import ContactAPI from "../../api/contactInfo";
import { useGlobalOrganizationContext } from "../../hooks/useGlobalOrganizationContext";
import { Organization } from "../../model";
import { OrganizationAddressLabels } from "../../model/Address";
import { ContactLabels, ContactType } from "../../model/Contact";
import CreateOrganizationComponent from "./components/CreateOrganizationComponent";

const CreateOrganizationPage: FC<unknown> = () => {
  const { organization, setOrganization, refreshOrganizations } =
    useGlobalOrganizationContext();
  const [newOrganization, setNewOrganization] = useState<
    Organization | undefined
  >();
  const navigate = useNavigate();

  // state for tracking whether or not the wizard is completed
  const [completed, setCompleted] = useState<boolean>(false);

  useEffect(() => {
    setOrganization(undefined);
  }, [setOrganization, organization]);

  if (organization) {
    return <></>;
  }

  return (
    <Box sx={{ maxWidth: "60%", margin: "auto", mt: 2 }}>
      <CreateOrganizationComponent
        onCreate={(organization, items) => {
          setNewOrganization(organization);
          refreshOrganizations();

          if (items) {
            if (items.billingAddress) {
              try {
                AddressAPI.create(
                  items.billingAddress,
                  organization.id,
                  OrganizationAddressLabels.BILLING,
                );
              } catch (e) {
                console.error(e);
              }
            }

            if (items.primaryAddress) {
              try {
                AddressAPI.create(
                  items.primaryAddress,
                  organization.id,
                  OrganizationAddressLabels.PRIMARY,
                );
              } catch (e) {
                console.error(e);
              }
            }

            if (items.billingPhone) {
              try {
                ContactAPI.create({
                  organization_id: organization.id,
                  contact_type: ContactType.PHONE,
                  label: ContactLabels.BILLING,
                  value: items.billingPhone,
                  id: "",
                  user_id: "",
                });
              } catch (e) {
                console.error(e);
              }
            }

            if (items.billingEmail) {
              try {
                ContactAPI.create({
                  organization_id: organization.id,
                  contact_type: ContactType.EMAIL,
                  label: ContactLabels.BILLING,
                  value: items.billingEmail,
                  id: "",
                  user_id: "",
                });
              } catch (e) {
                console.error(e);
              }
            }

            if (items.primaryEmail) {
              try {
                ContactAPI.create({
                  organization_id: organization.id,
                  contact_type: ContactType.EMAIL,
                  label: ContactLabels.PRIMARY,
                  value: items.primaryEmail,
                  id: "",
                  user_id: "",
                });
              } catch (e) {
                console.error(e);
              }
            }

            if (items.primaryPhone) {
              try {
                ContactAPI.create({
                  organization_id: organization.id,
                  contact_type: ContactType.PHONE,
                  label: ContactLabels.PRIMARY,
                  value: items.primaryPhone,
                  id: "",
                  user_id: "",
                });
              } catch (e) {
                console.error(e);
              }
            }
          }

          setCompleted(true);
        }}
      />
      {completed && (
        <Box sx={{ margin: "auto" }}>
          <Box sx={{ my: 4 }}>
            <Typography>Your organization was created successfully!</Typography>
            <Button
              sx={{ my: 2 }}
              variant="contained"
              onClick={() => {
                setOrganization(newOrganization);
                navigate("/user/organization/members");
              }}
            >
              Invite Your Team
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default CreateOrganizationPage;
